import type { HeatPumpKpiWidget } from '../../../widgets';
import {
  BindingRow,
  OptionalBindingRow,
  Section,
  TextField,
  patcher,
  type WidgetEditorProps,
} from '../fields';
import { AiHintSection } from './AiHintSection';

export function HeatPumpKpiEditor(
  { widget, plantId, missing, onChange }: WidgetEditorProps<HeatPumpKpiWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Wärmepumpe">
        <TextField
          label="Name der Wärmepumpe"
          value={widget.heatPumpName}
          keepEmptyString
          required
          missing={missing.has('heatPumpName')}
          placeholder="Vaillant aroTHERM 10 kW"
          onChange={(next) => patch({ heatPumpName: next ?? '' })}
        />
      </Section>

      <Section title="Leistung">
        <BindingRow
          label="Elektrische Leistung"
          value={widget.electricalPowerPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ electricalPowerPoint: next })}
        />
        <OptionalBindingRow
          label="Thermische Leistung"
          value={widget.thermalPowerPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          hint="Ohne sie zeigt die Kachel nur die Aufnahme, keine Arbeitszahl."
          onChange={(next) => patch({ thermalPowerPoint: next })}
        />
        <OptionalBindingRow
          label="Arbeitszahl (COP)"
          value={widget.copPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          hint="Leer lassen, wenn der Regler keine eigene meldet: dann wird sie aus thermisch durch elektrisch gerechnet."
          onChange={(next) => patch({ copPoint: next })}
        />
      </Section>

      <Section title="Zustand und Umgebung">
        <BindingRow
          label="Betriebszustand"
          value={widget.statePoint}
          plantId={plantId}
          filter={{ valueType: 'enum' }}
          hint="Aus, Bereit, Anlauf, Betrieb, Abtauung, Störung."
          onChange={(next) => patch({ statePoint: next })}
        />
        <OptionalBindingRow
          label="Vorlauf"
          value={widget.flowTemperaturePoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ flowTemperaturePoint: next })}
        />
        <OptionalBindingRow
          label="Außentemperatur"
          value={widget.outsideTemperaturePoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          hint="Ohne sie ist eine Arbeitszahl von 3 nicht einzuordnen."
          onChange={(next) => patch({ outsideTemperaturePoint: next })}
        />
      </Section>

      <Section title="Zähler">
        <OptionalBindingRow
          label="Laufzeit heute"
          value={widget.runtimeTodayPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ runtimeTodayPoint: next })}
        />
        <OptionalBindingRow
          label="Laufzeit gesamt"
          value={widget.runtimeLifetimePoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ runtimeLifetimePoint: next })}
        />
        <OptionalBindingRow
          label="Verdichterstarts heute"
          value={widget.compressorStartsTodayPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          hint="Häufiges Takten kostet Lebensdauer. Der Wert, nach dem der Techniker sucht."
          onChange={(next) => patch({ compressorStartsTodayPoint: next })}
        />
      </Section>

      <AiHintSection value={widget.ai} onChange={(next) => patch({ ai: next })} />
    </>
  );
}
